module.exports = __webpack_public_path__ + "img/top.11b708b5.png";